import { Status } from '@vendasta/task-manager';
import { StatusOption } from './interfaces';

export enum RouteParamKeys {
  Partner = 'FulfillmentOrderPartner',
  FulfillmentOrderId = 'FulfillmentOrderId',
}

export const ProjectStatusMap = new Map<string, StatusOption>([
  [Status.Open, { name: Status.Open, color: 'grey' }],
  [Status.InProgress, { name: Status.InProgress, color: 'yellow' }],
  [Status.WaitingOnCustomer, { name: Status.WaitingOnCustomer, color: 'red' }],
  [Status.Completed, { name: Status.Completed, color: 'green' }],
]);

export const METADATA_KEYS = {
  FulfillmentOrderId: 'fulfillmentOrderId',
  FulfillingPartnerId: 'FulfillingPartnerId',
};

export const TASK_TYPES = {
  Project: 'Project',
};

export type OrderDetailSection = 'submittedBy' | 'account' | 'salesOrderId' | 'product' | 'pricing';
